import {request} from "../../Base/HTTP";
import HttpMethod from "../../Constants/Base/HttpMethod";

export async function getCheckListTemplateSteps(data) {
    return await request('/api/check-list-template-step', data);
}

export async function addCheckListTemplateStep(data) {
    return await request('/api/check-list-template-step', data, HttpMethod.POST);
}